import { useState } from 'react';

const Services = () => {
  const [activeCategory, setActiveCategory] = useState('klippning');

  const services = {
    klippning: {
      title: 'Klippning',
      items: [
        { name: 'Damklippning', time: '45 min', price: 'Från 780 kr' },
        { name: 'Lyxklippning kort hår', time: '60 min', price: 'Från 655 kr' },
        { name: 'Lyxklippning långt hår', time: '75 min', price: 'Från 890 kr' },
        { name: 'Herrklippning', time: '45 min', price: 'Från 550 kr' },
        { name: 'Klippning Junior kort 10-15 år', time: '30 min', price: 'Från 490 kr' },
        { name: 'Barnklippning', time: '30 min', price: 'Från 422 kr' },
        { name: 'Skin Fade', time: '60 min', price: '599 kr' },
      ]
    },
    fargning: {
      title: 'Färgning',
      items: [
        { name: 'Färgning utväxt kort', time: '90 min', price: '1 403 kr' },
        { name: 'Färgning utväxt långt hår', time: '90 min', price: 'Från 1 507 kr' },
        { name: 'Färgning långt hår', time: '120 min', price: '1 829 kr' },
        { name: 'Nyansering kort hår', time: '45 min', price: 'Från 811 kr' },
        { name: 'Nyansering långt hår', time: '60 min', price: 'Från 1 019 kr' },
        { name: 'Slingor kort hår', time: '105 min', price: 'Från 1 649 kr' },
        { name: 'Slingor långt hår', time: '135 min', price: 'Från 1 979 kr' },
        { name: 'Balayage', time: '150 min', price: 'Från 2 800 kr' },
      ]
    },
    styling: {
      title: 'Styling',
      items: [
        { name: 'Tvätt, fön och styling kort hår', time: '30 min', price: 'Från 500 kr' },
        { name: 'Tvätt, fön, styling långt hår', time: '45 min', price: 'Från 750 kr' },
        { name: 'Lyxig tvätt & fön', time: '60 min', price: 'Från 676 kr' },
        { name: 'Snabbstyling', time: '30 min', price: '399 kr' },
        { name: 'Håruppsättning', time: '90 min', price: 'Från 989 kr' },
      ]
    },
    behandling: {
      title: 'Behandlingar',
      items: [
        { name: 'Olaplexbehandling utan klipp', time: '60 min', price: '1 019 kr' },
        { name: 'Olaplexbehandling inkl. klipp', time: '90 min', price: '1 319 kr' },
        { name: 'Permanent konsultation', time: '15 min', price: '55 kr' },
        { name: 'Permanent kort hår', time: '120 min', price: '1 949 kr' },
        { name: 'Permanent långt hår', time: '165 min', price: '2 249 kr' },
      ]
    },
    extensions: {
      title: 'Extensions (Hairtalk)',
      items: [
        { name: 'Hairtalk konsultation', time: '15 min', price: 'Från 156 kr' },
        { name: 'Hairtalk omsättning', time: '60 min', price: '1 800 kr' },
        { name: 'Hairtalk uttag', time: '75 min', price: 'Kontakta salongen' },
        { name: 'Hairtalk uttag + omsättning', time: '120 min', price: 'Kontakta salongen' },
      ]
    },
    bryn: {
      title: 'Bryn & Fransar',
      items: [
        { name: 'Fransfärg, brynfärg inkl. brynplock', time: '45 min', price: '519 kr' },
        { name: 'Brynfärg inkl. brynplock', time: '30 min', price: '342 kr' },
        { name: 'Fransfärg', time: '30 min', price: '342 kr' },
        { name: 'Brynfärg', time: '15 min', price: '259 kr' },
        { name: 'Brynplock', time: '15 min', price: '259 kr' },
      ]
    },
  };

  const categories = [
    { key: 'klippning', label: 'Klippning' },
    { key: 'fargning', label: 'Färgning' },
    { key: 'styling', label: 'Styling' },
    { key: 'behandling', label: 'Behandlingar' },
    { key: 'extensions', label: 'Extensions' },
    { key: 'bryn', label: 'Bryn & Fransar' },
  ];

  return (
    <section id="services" className="section">
      <div className="container mx-auto">
        {/* Section Header */}
        <div className="text-center mb-10 sm:mb-12 md:mb-16">
          <p className="text-heading mb-3 sm:mb-4 text-sm sm:text-base">Våra tjänster</p>
          <h2 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl mb-4 sm:mb-6">Prislista</h2>
          <div className="divider" />
        </div>

        {/* Category Tabs */}
        <div className="flex flex-wrap justify-center gap-2 sm:gap-3 md:gap-4 mb-8 sm:mb-10 md:mb-12">
          {categories.map((cat) => (
            <button
              key={cat.key}
              onClick={() => setActiveCategory(cat.key)}
              className={`px-3 py-2 sm:px-4 sm:py-2.5 md:px-6 md:py-3 text-xs sm:text-sm uppercase tracking-widest transition-all rounded ${
                activeCategory === cat.key
                  ? 'bg-[var(--color-accent-800)] text-white'
                  : 'bg-[var(--color-bg-tertiary)] text-[var(--color-text-secondary)] hover:bg-[var(--color-accent-300)]'
              }`}
            >
              {cat.label}
            </button>
          ))}
        </div>

        {/* Services List */}
        <div className="max-w-4xl mx-auto">
          <div className="mb-8 sm:mb-10 md:mb-12">
            {services[activeCategory].items.map((item, itemIndex) => (
              <div
                key={itemIndex}
                className="border-b border-[var(--color-border-light)] py-4 sm:py-5 md:py-6 hover:bg-[var(--color-bg-tertiary)] transition-colors px-3 sm:px-4 md:px-6 rounded-lg"
              >
                <div className="flex justify-between items-start mb-1 sm:mb-2">
                  <h3 className="text-base sm:text-lg md:text-xl font-light flex-1 pr-2">{item.name}</h3>
                  <span className="text-base sm:text-lg md:text-xl text-[var(--color-accent-800)] font-light whitespace-nowrap">{item.price}</span>
                </div>
                <p className="text-xs sm:text-sm text-[var(--color-text-light)]">{item.time}</p>
              </div>
            ))}
          </div>
        </div>

        {/* CTA */}
        <div className="text-center mt-10 sm:mt-12 md:mt-16">
          <p className="text-sm sm:text-base text-[var(--color-text-secondary)] mb-4 sm:mb-6 px-4">
            Vill du veta mer om våra behandlingar? Kontakta oss eller boka tid direkt online.
          </p>
          <a href="https://www.bokadirekt.se/places/hargalleriet-selma-p-57369" target="_blank" rel="noopener noreferrer">
            <button className="btn text-xs sm:text-sm">Boka tid online</button>
          </a>
        </div>
      </div>
    </section>
  );
};

export default Services;
